import http from '../../service/http/http';
import { getVisitorId } from '../../plugins/helper';

const state = {
  leiloesDestaque: [],
  leiloesAbertos: [],
  leiloesFechados: [],
  leiloesEmbreve: [],
  leiloesParceiros: [],
  leiloesPesquisa: [],
  leiloesPesquisaLoading: false,
  leiloesPesquisaNextPage: false,
  leiloesPesquisaTotal: 0,
  leilaoLoading: {
    destaque: false,
    aberto: false,
    breve: false,
    fechado: false,
    verificacao: false
  },
  leilao: '',
  leilaoHabilitado: '',
  leilaoErro: null,
  solicitacaoAcesso: '',
  reenviaCodigoLoading: '',
  isNextPage: '',
  leiloeiro: null,
  leiloeiroLoading: false
};

const mutations = {
  SET_LEILOES_DESTAQUE: (state, value) => (value ? (state.leiloesDestaque = value) : (state.leiloesDestaque = [])),
  SET_LEILOES_ABERTO: (state, value) => (value ? state.leiloesAbertos.push(...value) : (state.leiloesAbertos = [])),
  SET_LEILOES_FECHADO: (state, value) => (value ? state.leiloesFechados.push(...value) : (state.leiloesFechados = [])),
  SET_LEILOES_BREVE: (state, value) => (value ? state.leiloesEmbreve.push(...value) : (state.leiloesEmbreve = [])),
  SET_LEILAO_DESTAQUE_LOADING: (state, value) => (value ? (state.leilaoLoading.destaque = value) : (state.leilaoLoading.destaque = false)),
  SET_LEILAO_ABERTO_LOADING: (state, value) => (value ? (state.leilaoLoading.aberto = value) : (state.leilaoLoading.aberto = false)),
  SET_LEILAO_BREVE_LOADING: (state, value) => (value ? (state.leilaoLoading.breve = value) : (state.leilaoLoading.breve = false)),
  SET_LEILAO_FECHADO_LOADING: (state, value) => (value ? (state.leilaoLoading.fechado = value) : (state.leilaoLoading.fechado = false)),
  SET_LEILAO_VERIFICACAO_LOADING: (state, value) => (value ? (state.leilaoLoading.verificacao = value) : (state.leilaoLoading.verificacao = false)),
  SET_LEILAO: (state, value) => (value ? (state.leilao = value) : (state.leilao = '')),
  SET_LEILAO_HABILITADO: (state, value) => (value ? (state.leilaoHabilitado = value) : (state.leilaoHabilitado = '')),
  SET_LEILAO_ERRO: (state, value) => (value ? (state.leilaoErro = value) : (state.leilaoErro = null)),
  SET_SOLICITACAO_ACESSO: (state, value) => (value ? (state.solicitacaoAcesso = value) : (state.solicitacaoAcesso = '')),
  SET_REENVIA_LOADING: (state, value) => (value ? (state.reenviaCodigoLoading = value) : (state.reenviaCodigoLoading = '')),
  IS_NEXT_PAGE: (state, value) => (value ? (state.isNextPage = value) : (state.isNextPage = '')),
  SET_LEILOES_PARCEIRO: (state, value) => (value ? (state.leiloesParceiros = value) : (state.leiloesParceiros = [])),
  SET_LEILOEIRO: (state, value) => (value ? (state.leiloeiro = value) : (state.leiloeiro = null)),
  SET_LEILOEIRO_LOADING: (state, value) => (value ? (state.leiloeiroLoading = value) : (state.leiloeiroLoading = false)),
  SET_LEILOES_PESQUISA: (state, value) => (value ? state.leiloesPesquisa.push(...value) : (state.leiloesPesquisa = [])),
  SET_LEILOES_PESQUISA_LOADING: (state, value) => (value ? (state.leiloesPesquisaLoading = value) : (state.leiloesPesquisaLoading = false)),
  SET_LEILOES_PESQUISA_NEXT_PAGE: (state, value) => (state.leiloesPesquisaNextPage = value || false),
  SET_LEILOES_PESQUISA_TOTAL: (state, value) => (state.leiloesPesquisaTotal = value || 0)
};

const getters = {
  getLeiloesParceiro(state) {
    return state.leiloesParceiros;
  },
  getLeiloesDestaque(state) {
    return state.leiloesDestaque;
  },
  getLeiloesAberto(state) {
    return state.leiloesAbertos;
  },
  getLeiloesFechado(state) {
    return state.leiloesFechados;
  },
  getLeiloesBreve(state) {
    return state.leiloesEmbreve;
  },
  getLeiloesDestaqueLoading(state) {
    return state.leilaoLoading.destaque;
  },
  getLeiloesAbertoLoading(state) {
    return state.leilaoLoading.aberto;
  },
  getLeiloesBreveLoading(state) {
    return state.leilaoLoading.breve;
  },
  getLeiloesFechadoLoading(state) {
    return state.leilaoLoading.fechado;
  },
  getLeiloesVerificacaoLoading(state) {
    return state.leilaoLoading.verificacao;
  },
  getLeilao(state) {
    return state.leilao;
  },
  getLeilaoHabilitado(state) {
    return state.leilaoHabilitado;
  },
  getLeilaoErro(state) {
    return state.leilaoErro;
  },
  getSolicitacaoAcesso(state) {
    return state.solicitacaoAcesso;
  },
  getReenviaCodigoLoading(state) {
    return state.reenviaCodigoLoading;
  },
  getIsNextPage(state) {
    return state.isNextPage;
  },
  getLeiloeiro(state) {
    return state.leiloeiro;
  },
  getLeiloeiroLoading(state) {
    return state.leiloeiroLoading;
  },
  getLeiloesPesquisa(state) {
    return state.leiloesPesquisa;
  },
  getLeiloesPesquisaLoading(state) {
    return state.leiloesPesquisaLoading;
  },
  getLeiloesPesquisaNextPage(state) {
    return state.leiloesPesquisaNextPage;
  },
  getLeiloesPesquisaTotal(state) {
    return state.leiloesPesquisaTotal;
  }
};

const actions = {
  async setLeiloesParceiro({ commit }, filtro) {
    return new Promise((resolve, reject) => {
      commit('SET_LEILOES_PARCEIRO', true);
      return http({
        url: `leilaoParceiro${filtro && filtro.categoriaId ? `?CategoriaId=${filtro.categoriaId}` : ''}`,
        method: 'get'
      })
        .then((resp) => {
          commit('SET_LEILOES_PARCEIRO', resp.data);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  async setLeiloesDestaque({ commit }, filtro) {
    return new Promise((resolve, reject) => {
      commit('SET_LEILAO_DESTAQUE_LOADING', true);

      const params = new URLSearchParams();
      if (filtro && filtro.categoriaId) {
        params.append('CategoriaId', String(filtro.categoriaId));
      }

      const queryString = params.toString();
      const url = `leilao/destaques${queryString ? `?${queryString}` : ''}`;

      return http({
        url,
        method: 'get'
      })
        .then((resp) => {
          commit('SET_LEILOES_DESTAQUE', resp.data);
          commit('SET_LEILAO_DESTAQUE_LOADING');
          resolve();
        })
        .catch(() => {
          commit('SET_LEILAO_DESTAQUE_LOADING');
          reject();
        });
    });
  },
  async setLeiloesPorStatus({ commit }, value) {
    // let status = value.status && value.status.toUpperCase()
    return new Promise((resolve, reject) => {
      let status = value.status && value.status.toUpperCase();
      commit('SET_LEILAO_' + status + '_LOADING', true);
      const categoriaParam = value.categoriaId && value.categoriaId !== 0 ? `&CategoriaId=${value.categoriaId}` : '';
      return http({
        url: `leilao?pageSize=${value.pageSize}&pageNumber=${value.pageNumber}&status=${value.status}${categoriaParam}`,
        method: 'get'
      })
        .then((resp) => {
          commit('SET_LEILOES_' + status, resp.data?.data);
          commit('IS_NEXT_PAGE', resp.data.nextPage);
          commit('SET_LEILAO_' + status + '_LOADING');
          resolve();
        })
        .catch(() => {
          commit('SET_LEILAO_' + status + '_LOADING');
          reject();
        });
    });
  },
  async pesquisarLeiloes({ commit }, value) {
    return new Promise((resolve, reject) => {
      commit('SET_LEILOES_PESQUISA_LOADING', true);

      const params = {
        PageSize: value.pageSize || 8,
        PageNumber: value.pageNumber || 1
      };

      if (value.status) {
        params['Status'] = value.status;
      }
      if (value.termo) {
        params['Termo'] = value.termo;
      }
      if (value.categoriaId) {
        params['CategoriaId'] = value.categoriaId;
      }
      if (value.excetoCategoriasIds) {
        params['ExcetoCategoriasIds'] = value.excetoCategoriasIds;
      }

      return http({
        url: 'leilao',
        method: 'get',
        params
      })
        .then((resp) => {
          if (value.pageNumber === 1) {
            commit('SET_LEILOES_PESQUISA');
          }
          const dataLimpa = Array.isArray(resp.data?.data)
            ? resp.data.data.map((l) => {
                if (l && l.foto && typeof l.foto.url === 'string') {
                  l.foto = {
                    ...l.foto,
                    url: l.foto.url.replace(/^[`'"]+|[`'"]+$/g, '').trim()
                  };
                }
                return l;
              })
            : resp.data?.data;
          commit('SET_LEILOES_PESQUISA', dataLimpa);
          commit('SET_LEILOES_PESQUISA_NEXT_PAGE', resp.data.nextPage);
          commit('SET_LEILOES_PESQUISA_TOTAL', resp.data.totalRecords);
          commit('SET_LEILOES_PESQUISA_LOADING', false);
          resolve();
        })
        .catch(() => {
          commit('SET_LEILOES_PESQUISA_LOADING', false);
          reject();
        });
    });
  },

  async setLeilao({ commit, state }, value) {
    if (state.leilao && state.leilao.id == value) return;
    commit('SET_LEILAO', null);

    return http({
      url: `leilao/${value}`,
      method: 'get'
    })
      .then((resp) => {
        commit('SET_LEILAO', resp.data.data);
      })
      .catch(() => commit('SET_LEILAO'));
  },

  async verificarAcesso({ commit, state }, value) {
    if (state.leilaoLoading.verificacao) return;

    commit('SET_LEILAO_VERIFICACAO_LOADING', true);
    commit('SET_LEILAO_HABILITADO', false);
    return http({
      url: `Leilao/${value}/verificar-acesso`,
      method: 'get'
    })
      .then((resp) => {
        commit('SET_LEILAO_HABILITADO', resp.data.data);
        commit('SET_LEILAO_VERIFICACAO_LOADING');
      })
      .catch(() => commit('SET_LEILAO_VERIFICACAO_LOADING'));
  },

  async solicitaAcesso({ commit, state }, value) {
    if (state.leilaoLoading.verificacao) return;

    commit('SET_LEILAO_VERIFICACAO_LOADING', true);
    const payload = {
      regraHabilitacaoId: value.regraHabilitacaoId,
      para: value.para,
      aceiteTermo: true
    };
    return http({
      url: `Leilao/${value.leilaoId}/solicitar-acesso`,
      method: 'post',
      data: payload
    })
      .then((resp) => {
        //console.log(resp);
        commit('SET_SOLICITACAO_ACESSO', resp.data.data);
        commit('SET_LEILAO_VERIFICACAO_LOADING');
        commit('SET_LEILAO_ERRO');
      })
      .catch(() => {
        //console.log(err);
        commit('SET_LEILAO_VERIFICACAO_LOADING');
        commit('SET_LEILAO_ERRO', { mensagem: 'Erro ao enviar o código' });
      });
  },
  async validaAcesso({ commit, state }, value) {
    if (state.leilaoLoading.verificacao) return;
    commit('SET_LEILAO_VERIFICACAO_LOADING', true);
    const payload = {
      solicitacaoId: value.solicitacaoId,
      codigo: value.codigo
    };
    return http({
      url: `Leilao/${value.leilaoId}/validar-acesso`,
      method: 'get',
      params: payload
    })
      .then(() => {
        //console.log(resp);
        commit('SET_LEILAO_VERIFICACAO_LOADING');
        commit('SET_LEILAO_ERRO');
      })
      .catch(() => {
        //console.log(err);
        commit('SET_LEILAO_VERIFICACAO_LOADING');
        commit('SET_LEILAO_ERRO', { mensagem: 'Código inválido' });
      });
  },

  async reenviaCodigo({ commit, state }, value) {
    if (state.reenviaCodigoLoading) return;

    commit('SET_REENVIA_LOADING', true);
    const payload = {
      to: value.to,
      channel: value.channel
    };
    return http({
      url: `Verificacao/Enviar-Codigo`,
      method: 'post',
      data: payload
    })
      .then(() => {
        //console.log(resp);
        commit('SET_REENVIA_LOADING');
        commit('SET_LEILAO_ERRO');
      })
      .catch(() => {
        //console.log(err);
        commit('SET_REENVIA_LOADING');
        commit('SET_LEILAO_ERRO', { mensagem: 'Código inválido' });
      });
  },
  async clickLeilaoParceiro(_, value) {
    return http({
      url: `leilaoParceiro/${value}/click`,
      method: 'post',
      data: {
        visitorToken: getVisitorId()
      }
    });
  },
  async setLeiloeiroPublico({ commit }, slug) {
    commit('SET_LEILOEIRO', null);
    commit('SET_LEILOEIRO_LOADING', true);
    return http({
      url: `leiloeiro/publico/${slug}`,
      method: 'get'
    })
      .then((resp) => {
        commit('SET_LEILOEIRO', resp.data?.data);
        commit('SET_LEILOEIRO_LOADING', false);
      })
      .catch(() => commit('SET_LEILOEIRO_LOADING', false));
  },
  async setLeiloesPorStatusLeiloeiro({ commit }, value) {
    return new Promise((resolve, reject) => {
      let status = value.status && value.status.toUpperCase();
      commit('SET_LEILAO_' + status + '_LOADING', true);
      return http({
        url: `leiloeiro/publico/${value.slug}/leiloes?pageSize=${value.pageSize}&pageNumber=${value.pageNumber}&status=${value.status}`,
        method: 'get'
      })
        .then((resp) => {
          commit('SET_LEILOES_' + status, resp.data?.data);
          commit('IS_NEXT_PAGE', resp.data.nextPage);
          commit('SET_LEILAO_' + status + '_LOADING');
          resolve();
        })
        .catch(() => {
          commit('IS_NEXT_PAGE', '');
          commit('SET_LEILAO_' + status + '_LOADING');
          reject();
        });
    });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
